<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
             <!-- <van-notice-bar 
             v-if="row.club2grade" v-rblink="{name:'MyClub'}"
                text="您已具备申请二星俱乐部资质，请尽快升级俱乐部资质。点击前往>>"
                /> -->
        <div class="danwei-warp">
            <div class="title">{{row.danwei}}</div>
            <div class="saiqu">{{row.saiqu.name}}</div>
            <div class="duiwu">{{row.mingcheng}}</div>

            <img :src="row.saiqu.erweiimg[0].url" v-if="row.saiqu.erweiimg.length>0" style="width: 200px;
    margin-top: 20px;" />
            <p v-if="row.saiqu.erweiimg.length>0" style="color:#f00" >{{row.saiqu.name}}<br />扫码加工作人员好友，进入赛事微信群</p>
        </div>

        <div class="step-warp">
            <van-steps direction="vertical"  active-color="#00B388" :active="active">
                <van-step>
                    <div class="step-li">
                        <div class="title">填写秩序册</div>
                        <p class="desc">完善队伍信息</p>
                        <div class="right tiny-btn-0"  @click="goStep1()" v-if="row.memberstatus>0&&row.memberstatus<5">修改信息</div>
                        <div class="right tiny-btn-0" style="right: 80px;" v-if="row.can_fc"  @click="goStepFc()" >风采口号</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">完善项目信息</div>
                        <p class="desc">选择项目以及相关运动员</p>
                        <div class="right tiny-btn-0" @click="goStep2()" v-if="row.memberstatus>1&&row.memberstatus<5">修改信息</div>
                        <div class="right tiny-btn-1" style="right: 80px;" @click="musicUrlShow=true"  v-if="row.memberstatus>1&&row.saiqu.is_jizan==2">上传/修改音乐</div>
                        <div class="right tiny-btn-1" @click="goStep2()" v-if="row.memberstatus==1">继续操作</div>
                    </div>
                </van-step>
                <van-step v-if="row.saiqu.is_online==2||row.saiqu.is_online==3">
                    <div class="step-li">
                        <div class="title">选择食宿行服务</div>
                        <p class="desc">完善随行人员及房间信息</p>
                        <div class="right tiny-btn-0" v-rblink="{name:'ISaiApplyFormStep3',query:{id:row.id}}" v-if="row.memberstatus>2&&row.memberstatus!=6">修改信息</div>
                        <div class="right tiny-btn-1" v-rblink="{name:'ISaiApplyFormStep3',query:{id:row.id}}" v-if="row.memberstatus==2">继续操作</div>
                    </div>
                </van-step>
                <van-step v-if="row.saiqu.is_jizan==2" v-show="[751,767].indexOf(parseInt(row.saiqu.id))==-1">
                    <div class="step-li">
                        <div class="title">确认订单并支付</div>
                        <p class="desc">完善发票信息，支付费用</p>
                        <div class="right tiny-btn-0" style="right: 80px;" v-rblink="{name:'ISaiApplyAddress',query:{id:row.id}}"  >邮寄地址</div>
                        <!-- <div class="right tiny-btn-0" style="right: 80px;" v-rblink="{name:'ISaiApplyAddress',query:{id:row.id}}" v-if="row.memberstatus==4">邮寄地址</div> -->
                        <div class="right tiny-btn-1" v-rblink="{name:'ISaiApplyFormStep5',query:{id:row.id}}" v-if="row.memberstatus==4||row.memberstatus==5">支付费用</div>
                        <!--<div class="right tiny-btn-0" v-rblink="{name:'SaiApplyFapiao',query:{id:row.id}}" v-if="row.memberstatus==6">申请开票</div>-->
                    </div>
                </van-step>
                <van-step  v-if="row.saiqu.is_jiesong==1">
                    <div class="step-li">
                        <div class="title">抵/离酒店时间</div>
                        <p class="desc">抵/离酒店时间信息填写</p>
                        <div class="right tiny-btn-0" style="right: 80px;" v-rblink="{name:'saiConfirmDetail4',query:{id:row.id,from:'app'}}"  >到达时间</div>
                        <div class="right tiny-btn-0" style="" v-rblink="{name:'saiConfirmDetail5',query:{id:row.id,from:'app'}}"  >离开时间</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">报名成功</div>
                        <p class="desc">报名成功</p>
                        <div class="right tiny-btn-0" style="right: 100px" v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id,from:'app'}}" v-if="(row.memberstatus==6||row.memberstatus==-2) && row.saiqu.need_video==1 && !row.video_ok">上传视频</div>
                        <div class="right tiny-btn-0" style="right: 100px" v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id,from:'app'}}" v-if="(row.memberstatus==6||row.memberstatus==-2) && row.saiqu.need_video==1 && row.video_ok">视频已上传</div>

                        <div class="right tiny-btn-0" v-rblink="{name:'ZSaiApplyZanList',query:{id:row.id,from:'app'}}" v-if="row.memberstatus==6 && row.saiqu.is_jizan==1 && !row.jizan_ok">上传集赞</div>
                        <div class="right tiny-btn-0" v-rblink="{name:'ZSaiApplyZanList',query:{id:row.id,from:'app'}}" v-if="row.memberstatus==6 && row.saiqu.is_jizan==1 && row.jizan_ok">集赞已上传</div>

                        <div style="top:30px" class="right tiny-btn-1" v-rblink="{name:'ISaiCertList',query:{id:row.id}}" v-if="row.have_cert">下载证书</div>
                        <!-- <div style="right:100px;top:30px" class="right tiny-btn-1" v-rblink="{name:'Tpage2',query:{baoming_id:row.id}}" v-if="row.saiqu.level==1">活力校园参评</div> -->

                        
                    </div>
                </van-step>
            </van-steps>

            <van-dialog v-model="musicUrlShow" title="请在复制网址到电脑端操作" confirm-button-text="关闭" >
                <div style="text-align: center; padding:20px 0 ; line-height: 30px ">
                    <div
                            v-clipboard:copy="row.music_edit_url"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                        {{row.music_edit_url}}  <br/> <span  >复制</span>
                    </div>
                </div>
            </van-dialog>

            <van-action-sheet
                v-model="ltShow"
                :actions="ltActions"
                cancel-text="取消"
                @select="onLtSelect"
                close-on-click-action
                @cancel="ltShow=false"
            />
        </div>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .step-warp{
        margin: 0.2rem;
        border-radius:0.2rem;
        padding: 0.2rem;
        background: #fff;
    }
    .step-warp .step-li{
        color: #000;
        position: relative;
    }
    .step-warp .step-li .title{
        font-size: 14px;
    }
    .step-warp .step-li .desc{
        margin-top: 0.2rem;
        font-size: 12px;
        color: #666;
    }
    .step-warp .right{
        position: absolute;
        top:0;
        right: 0;
    }
    .danwei-warp{
        margin: 0.2rem;
        background: #fff;
        box-shadow:0px 0px 10px 0px rgba(204,204,204,0.5);
        border-radius:0.2rem;
        padding: 0.2rem;
    }
    .danwei-warp .title{
        font-size: 18px;
        color: #000;
        margin: 0.4rem 0.2rem 0.2rem 0.2rem;
        font-weight: bold;
    }
    .danwei-warp .saiqu{
        font-size: 14px;
        margin: 0rem 0.2rem 0.4rem 0.2rem;
        color: #666;
    }
    .danwei-warp .duiwu{
        font-size: 12px;
        margin: 0.4rem 0.2rem 0rem 0.2rem;
        color: #999;
    }
    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }

</style>
<script>
    import Vue from 'vue';
    import jquery from 'jquery';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Dialog,Field,Area,Form,Divider,Steps,Step, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';

    Vue.use(Cell).use(Dialog).use(CellGroup).use(Steps).use(Step).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyDetail',
        components: {
            [Field.name]: Field,
            PicUploader,
            CaipanPicker,
            JiaolianPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                musicUrlShow:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                ltImgSrc:'', 
                ltImgName: '',
                ltActions: [{name: '保存图片'}],

                ltShow: false,
                row: {
                    id:0,
                    saiqu_name:'',
                    numTypeName:'身份证',
                    danwei:'',
                    memberstatus:0,
                    ldcardtype:1,
                    ldsex:1,
                    saiqu:{
                        erweiimg:[]
                    },
                    heying:[{name:"选择商户.png",
                        save_name:"h5/2020-05-11/1589187988243621.png",
                        uid:"vc-upload-1589187988243621",
                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
                    }],
                    caipan:[],
                    jiaolian:[],
                    can_fc:false,
                },
            }
        },
        filters: {},
        computed:{
            active(){
                switch (this.row.memberstatus){
                    case 1:
                        return 1;
                    case 2:
                        return 1;
                    case 3:
                        return 2;
                    case 4:
                        return 2;
                    case 5:
                        return 2;
                    case 6:
                        return 4;
                }
            }
        },
        mounted() {
            document.title = '报名详情';
            let that = this;
            that.areaList = area;
            that.row.id = this.$route.query.id;
            this.fetch();

            window.rbMessage = function (data) {
                if(data == 'saiApplyDetailReload'){
                   // alert('that.fetch()')
                    that.fetch();
                }
            }
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onLtSelect(item) {
            let that = this;
            switch (item.name) {
                case '保存图片':
                console.log(that.ltImgSrc, that.ltImgName);
                appEvent({
                    name: 'downloadPic',
                    query: {
                    'filename': that.ltImgName,
                    'url': that.ltImgSrc
                    }
                });
                break;
            }
            },
            fetch(){
                let that = this;
                that.$api.get('/api/sai/stepDetail', {
                    id : that.row.id,
                }, (res) => {
                    that.row = Object.assign(that.row, res.data)


                    if(this.row.saiqu.erweiimg.length>0){
                        Dialog.confirm({
                            title: '报名须知',
                            message: '如果您已报名成功，请务必扫码进群',
                            confirmButtonText:'我知道了', 
                            showCancelButton:false
                        }).then(() => {
                        // on close 
                        }).catch(() => { 
                        });
                    }



                    if (true) {
                    setTimeout(() => {
                        jquery('img').each(function () {
                        jquery(this).longPress(() => {
                            console.log('longPress', jquery(this).attr('src'));
                            that.ltImgSrc = jquery(this).attr('src')
                            that.ltImgName = jquery(this).attr('title')
                            that.ltShow = true;
                        });
                        })
                    }, 500);
                    return false;
                    }
                })
            },
            goStep1(){
                if(this.row.saiqu.id==751 || this.row.saiqu.id==767){ 
                    rbLink({name:'ISaiApplyFormStep1Dianxin',query:{id:this.row.id}},'replace') 
                    return 
                }
                if(this.row.saiqu.is_jizan==1){
                    rbLink({name:'ZSaiApplyFormStep1',query:{id:this.row.id}},'replace') 
                }else{ 
                    rbLink({name:'ISaiApplyFormStep1',query:{id:this.row.id}},'replace') 
                }
            },
            goStepFc(){
                    rbLink({name:'ISaiApplyFormFc',query:{id:this.row.id}},'replace') 
            },
            goStep2(){
                if(this.row.saiqu.is_jizan==1){
                    rbLink({name:'ZSaiApplyFormStep2',query:{id:this.row.id}},'replace') 
                }else{ 
                    rbLink({name:'ISaiApplyFormStep2',query:{id:this.row.id}},'replace') 
                }
            },
            onCopy(e) {
                Toast.success('复制成功');
            },
            onError(e) {
                console.log('复制失败！');
            },

            onQuestion(){
                console.log('onQuestion')
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyDetail.vue?4fbeaa63